import firebase from "../../firebase";

export default function({ officeId, roomId }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingAdmin",
        funcName: "setDefaultRoom",
        data: {
            officeId,
            roomId
        }
    });
}
